import { Box, Drawer, IconButton } from '@mui/material'
import Icon from 'src/@core/components/icon'
import Autocomplete from 'src/layouts/components/Autocomplete'
import UserDropdown from 'src/@core/layouts/components/shared-components/UserDropdown'
import NotificationDropdown from 'src/@core/layouts/components/shared-components/NotificationDropdown'
import { useAuth } from 'src/hooks/useAuth'
import { useState, useCallback, useContext } from 'react'
import PopupNotification from 'src/views/components/popUpNotification'
import ClientLoginStatus from 'src/views/login/clientLoginStatus'
import { AuthContext } from 'src/context/AuthContext'
import SideBarContent from '../horizontal/SidebarContent'

const AppBarContent = props => {
  const { hidden, settings, toggleNavVisibility } = props
  const { notificationMessage, openPopUp, setOpenPopUp } = useContext(AuthContext)
  const auth = useAuth()
  const [open, setOpen] = useState(false)

  const toggleDrawer = state => () => {
    setOpen(state)
  }

  const handleClose = useCallback(() => {
    setOpenPopUp(false)
  }, [setOpenPopUp])

  return (
    <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box className='actions-left' sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>
        {hidden && !settings.navHidden ? (
          <IconButton color='inherit' sx={{ ml: -2.75 }} onClick={toggleNavVisibility}>
            <Icon icon='mdi:menu' />
          </IconButton>
        ) : null}
      </Box>

      <Box
        className='actions-right'
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', marginRight: '7%' }}>
          {auth.user && <Autocomplete hidden={hidden} settings={settings} />}

          {auth.user && (
            <>
              <NotificationDropdown settings={settings} />
              <UserDropdown settings={settings} />

              <PopupNotification
                message={notificationMessage} 
                open={openPopUp}
                handleClose={handleClose}
              />
            </>
          )}
        </Box>

        <Box
          sx={{ minWidth: '100px', display: 'flex', alignItems: 'center', color: 'white' }}
          onClick={toggleDrawer(true)}
        >
          <ClientLoginStatus />
          <Icon icon='mdi:chevron-down' style={{ marginLeft: '1px' }} />
        </Box>

        <Drawer
          anchor='right'
          open={open}
          onClose={toggleDrawer(false)}
          PaperProps={{
            sx: { width: 340, borderRadius: '12px 0 0 12px' }
          }}
        >
          <SideBarContent toggleDrawer={toggleDrawer} />
        </Drawer>
      </Box>
    </Box>
  )
}

export default AppBarContent
